import { useEffect, useState } from "react";

export function useSliderValue({ value, setDetails, length, max }) {
	const maxCount = Math.min(length, max);
	const [localValue, setLocalValue] = useState(value);

	useEffect(() => {
		const timer = setTimeout(() => {
			if (value !== localValue) {
				setDetails(localValue);
			}
		}, 500);
		return () => clearTimeout(timer);
	}, [localValue, setDetails, value]);

	// biome-ignore lint/correctness/useExhaustiveDependencies: synchronizacja tylko gdy zmieni się value z zewnątrz, nie przy lokalnym przesuwaniu suwaka
	useEffect(() => {
		if (value !== localValue) {
			setLocalValue(value);
		}
	}, [value]);

	// biome-ignore lint/correctness/useExhaustiveDependencies: przycinamy wartość tylko gdy zmieni się length (np. liczba pytań)
	useEffect(() => {
		if (length < localValue) {
			setLocalValue(length);
		}
	}, [length]);

	return {
		value: localValue,
		setValue: (value) => {
			setLocalValue(value);
		},
		maxCount,
	};
}
